import React, { useEffect } from "react";
import { Row, Col,Skeleton,Button } from "antd";
import "./AddEmployee.css";
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons";
import history from "../../routes/history";
import EmpComponent from "./EmpComponent/EmpComponent";
import { useDispatch, useSelector } from "react-redux";
import { getEmpAlbums } from "../../redux/actions";

export default function AddEmployee() {
  const dispatch = useDispatch();
  const resp = useSelector((state) => state.fetchAlbumsReducer.albums);
  const loading = useSelector((state) => state.fetchAlbumsReducer.loading);
  const deleteLoading = useSelector((state) => state.deleteEmpAlbumsReducer.loading);
  const error = useSelector((state) => state.fetchAlbumsReducer.error);
  const successDelete = useSelector(
    (state) => state.deleteEmpAlbumsReducer.success
  );
  let noOfPics;
  useEffect(() => {
    if (successDelete) {
      dispatch({ type: 'RESET_DELETE_SUCCESS' }); 
    }
    if(resp?.[0]?.Album_Pictures.length == 0){
      history.push('/companyprofile/empstaff');
    }
  }, [successDelete, dispatch]);
  
  useEffect(() => {
    dispatch(getEmpAlbums({ type: "PEOPL" }));
  }, [dispatch, successDelete]);

  return (
    <div className="emp-mainbg">
      <Col xs={24} sm={24} md={24} lg={24}>
        {/* <div class="modal" style={modalStyle}>
        <div class="modal-content">
          <Row style={{marginTop:'10px'}}>
            <div className={'alert-msg'}><CheckCircleFilled style={{ paddingRight: '5px' }} />Marquee saved successfully</div>
            <div className="close" onClick={closeAlert}>&times;</div>
          </Row>
        </div>
      </div> */}
        <div style={{ padding: "10px" }}> </div>
        <ArrowLeftOutlined
          className="emp-back"
          onClick={() => history.push("/companyprofile")}
        />
        
      </Col>
      <div className="emp-topcont">
        <div
        
          style={{ width:'800px',height:'auto'}}
          className="emp-subcont comp-subcont"
        >
          <div className="emp-heading">Company staff album</div>
          <div className="emp-txt">
            {/* Showcase your top talent to attract future employees. */}
            Showcase your top talent to attract future employees.
            <br />
            <p style={{ marginTop: "1rem", marginBottom: "20px" }}>
            Tell their story by adding their bio using the edit bio feature.
            </p>
          </div>
          <button
              className="comp-btn"
              // onClick={() => history.push("/uploademployeepic")}
              onClick={() => history.replace("/uploademployeepic")}
            >
              {deleteLoading ? <LoadingOutlined/>:
              '+ Add an employee'}
            </button>
          {loading ? (
            <div className={'skeletonImage'} >
              <Skeleton.Image active={true} />
              <br />
              <br />
              <Skeleton active={true} />
            </div>
          ) : (
            <Row>
              {resp?.length !== 0
                ? resp[0].Album_Pictures.map((item, index) => {
                    return (
                      <Col
                        key={index}
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        style={{ marginBottom: "20px" }}
                      >
                        <div className="emp-resp-marg">
                          <EmpComponent
                            id={item?._id}
                            Key={item?.Filename}
                            Size={item?.FileSize}
                            Name={item?.Name}
                            Title={item?.Title}
                            Description={item?.Description}
                            WorkCulture={item?.WorkCulture}
                          />
                        </div>
                      </Col>
                    );
                  })
                : null}
            </Row>
          )}
          <div
            style={{marginRight:'72%',width:'300px' ,marginTop:'4%'}}
            className="add-emp-btn"
          >
            <button
              className="emp-btn"
              // onClick={() => history.push("/uploademployeepic")}
              onClick={() => history.replace("/uploademployeepic")}
            >
              {deleteLoading ? <LoadingOutlined/>:
              '+ Add an employee'}
            </button>
          </div>
        </div>
        
     
      </div>
      <div className="compstaff" >
      <Button
              className="compdetails-back"
              
              onClick={() => history.push('/companyprofile')} >
              <span style={{color:'#3E3E3E'}}>Back to profile</span>
            </Button>
      </div>
    </div>
  );
}
